import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import DropdownIndicator from '../../common/DropdownIndicator';
import dropdownStyleUtils from '../../../dropdownStyleUtils';
import { isMobile } from '../../../screenUtils';
import './RoleChangeDropdown.scss';
var permissionsToStringMapping = {
  invoice_approver: 'Timesheet Approver',
  manager: 'Manager',
  collaborator: 'Collaborator',
  admin: 'Admin',
  owner: 'Admin (owner)'
};
var permissionsToString = function permissionsToString(permLevel) {
  return permissionsToStringMapping[permLevel];
};
var dropDownDescriptionMapping = {
  invoice_approver: 'Can approve and request edits on timesheets. Can add other timesheet approvers.',
  manager: 'Can edit posts, hire candidates, and invite coworkers. Can view hourly rates.',
  collaborator: 'Can view. Can comment on projects and candidates. Cannot view hourly rates.',
  admin: 'Can edit posts, hire candidates, approve timesheets, and add coworkers.',
  owner: 'Owner of the project. Has the same access level as an admin.'
};
var dropDownDescription = function dropDownDescription(permLevel) {
  return dropDownDescriptionMapping[permLevel];
};
var formatDropdownOptionsLabels = function formatDropdownOptionsLabels(option, context) {
  var isMenuOption = context.context === 'menu';
  if (isMenuOption) {
    var isSelected = context.selectValue.some(function (selected) {
      return selected.value === option.value;
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "role-menu-option menu-option-".concat(option.value)
    }, /*#__PURE__*/React.createElement("div", {
      className: "g-row--always g-row--between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "g-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "option-label-header mb-4"
    }, option.label), /*#__PURE__*/React.createElement("div", {
      className: "option-label-description"
    }, dropDownDescription(option.value))), isSelected && /*#__PURE__*/React.createElement("div", {
      className: "g-column"
    }, /*#__PURE__*/React.createElement("i", {
      className: "mx-3 check-icon fa fa-check",
      "aria-hidden": "true"
    }))));
  }
  return /*#__PURE__*/React.createElement("div", null, option.label);
};
var customStyles = {
  menu: function menu(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      width: state.selectProps.width,
      right: 0
    });
  }
};
function RoleChangeDropdown(_ref) {
  var enabled = _ref.enabled,
    showRemoveOption = _ref.showRemoveOption,
    value = _ref.value,
    permissionOptions = _ref.permissionOptions,
    onChange = _ref.onChange,
    handleRemove = _ref.handleRemove;
  var handleRoleChange = function handleRoleChange(newRole) {
    onChange(newRole);
  };
  var renderRemoveConfirmation = function renderRemoveConfirmation(cancelRemove) {
    return /*#__PURE__*/React.createElement("div", {
      className: "remove-colleague-confirmation"
    }, /*#__PURE__*/React.createElement("div", {
      className: "remove-colleague-confirmation-text"
    }, "Confirm removal"), /*#__PURE__*/React.createElement("div", {
      className: "mr-12"
    }, /*#__PURE__*/React.createElement("a", {
      className: "remove-colleague-button",
      onClick: handleRemove,
      role: "button",
      tabIndex: 0
    }, "Remove"), /*#__PURE__*/React.createElement("a", {
      className: "cancel-removal-button",
      onClick: cancelRemove,
      role: "button",
      tabIndex: 0
    }, "Cancel")));
  };
  var renderRemove = function renderRemove(askForConfirmation) {
    return /*#__PURE__*/React.createElement("a", {
      className: "remove-colleague-button",
      onClick: askForConfirmation,
      role: "button",
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-trash me-3",
      "aria-hidden": "true"
    }), "Remove colleague");
  };
  var options = permissionOptions.map(function (permLevel) {
    return {
      value: permLevel,
      label: permissionsToString(permLevel)
    };
  });
  var valueForSelectComponent = {
    value: value,
    label: permissionsToString(value)
  };
  var menuWidth = isMobile() ? '300px' : '400px';
  function MenuList(props) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      askForConfirm = _useState2[0],
      setAskForConfirm = _useState2[1];
    var askForConfirmation = function askForConfirmation() {
      return setAskForConfirm(true);
    };
    var cancelRemove = function cancelRemove() {
      return setAskForConfirm(false);
    };
    return /*#__PURE__*/React.createElement(components.MenuList, props, props.children, askForConfirm ? renderRemoveConfirmation(cancelRemove) : renderRemove(askForConfirmation));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "roles-dropdown-container"
  }, /*#__PURE__*/React.createElement(Select, {
    classNamePrefix: "roles-dropdown",
    options: options,
    placeholder: "Select role",
    value: valueForSelectComponent,
    onChange: function onChange(newSelection) {
      return handleRoleChange(newSelection.value);
    },
    isDisabled: !enabled,
    formatOptionLabel: formatDropdownOptionsLabels,
    styles: _objectSpread(_objectSpread({}, customStyles), dropdownStyleUtils),
    width: menuWidth,
    components: {
      MenuList: showRemoveOption ? MenuList : components.MenuList,
      DropdownIndicator: DropdownIndicator,
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      }
    }
  }));
}
RoleChangeDropdown.propTypes = {
  permissionOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  enabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  showRemoveOption: PropTypes.bool,
  handleRemove: PropTypes.func
};
RoleChangeDropdown.defaultProps = {
  enabled: true,
  showRemoveOption: false,
  handleRemove: function handleRemove() {
    return null;
  }
};
export default RoleChangeDropdown;